module.exports = __webpack_public_path__ + "static/media/200221_MX_Monopoly_Website_Enquiry-_-Redeem-Prize_coupon.edcf2848.png";